module.exports = __webpack_public_path__ + "img/Logo_SAC.face84da.svg";